import script from "./Cart.vue?vue&type=script&setup=true&lang=ts"
export * from "./Cart.vue?vue&type=script&setup=true&lang=ts"

import "./Cart.vue?vue&type=style&index=0&id=49b760e8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-49b760e8"]])

export default __exports__